import { forwardRef } from '@chakra-ui/react';
import { SelectField } from './SelectField';
import { COUNTRIES } from '../../constants';

export const SelectCountry = forwardRef(({ ...rest }, ref) => (
  <SelectField {...rest} options={COUNTRIES} inputRef={ref} />
));
